import { Translatable } from './translatable';

import * as _ from 'lodash';

import { FileRef } from './file-ref';

export class SFLLocation extends Translatable {
  public static readonly CLASS_NAME = 'Location';
  public static readonly TITLE_KEY = 'title';
  public static readonly SUBTITLE_KEY = 'subtitle';
  public static readonly GEO_POINT_KEY = 'geoPoint';
  public static readonly CONTENT_KEY = 'content';
  public static readonly SORT_ORDER_KEY = 'sortOrder';
  public static readonly CITY_KEY = 'city';
  public static readonly COUNTRY_KEY = 'country';
  public static readonly ADDRESS_LINE_1_KEY = 'addressLine1';

  public static readonly DEFAULT_LATITUDE = 11.5448729;
  public static readonly DEFAULT_LONGITUDE = 104.89216680000004;

  constructor() {
    super(SFLLocation.CLASS_NAME);
    this.geoPoint = new Parse.GeoPoint(SFLLocation.DEFAULT_LATITUDE, SFLLocation.DEFAULT_LONGITUDE);
  }

  // ===============================================================================================
  // Translations
  // ===============================================================================================

  public getTitle(lang: string): string {
    return this.getTranslation(SFLLocation.TITLE_KEY, lang);
  }

  public setTitle(title: string, lang: string) {
    this.setTranslation(SFLLocation.TITLE_KEY, title, lang);
  }

  public getSubtitle(lang: string): string {
    return this.getTranslation(SFLLocation.SUBTITLE_KEY, lang);
  }

  public setSubtitle(subtitle: string, lang: string) {
    this.setTranslation(SFLLocation.SUBTITLE_KEY, subtitle, lang);
  }

  public getContent(lang: string): string {
    return this.getTranslation(SFLLocation.CONTENT_KEY, lang);
  }

  public setContent(content: string, lang: string) {
    this.setTranslation(SFLLocation.CONTENT_KEY, content, lang);
  }

  // ===============================================================================================
  // Accessors
  // ===============================================================================================

  public get sortOrder(): number {
    return this.get(SFLLocation.SORT_ORDER_KEY);
  }

  public set sortOrder(sortOrder: number) {
    this.set(SFLLocation.SORT_ORDER_KEY, sortOrder);
  }

  public get city(): string {
    return this.get(SFLLocation.CITY_KEY);
  }

  public set city(city: string) {
    this.set(SFLLocation.CITY_KEY, city);
  }

  public get country(): string {
    return this.get(SFLLocation.COUNTRY_KEY);
  }

  public set country(country: string) {
    this.set(SFLLocation.COUNTRY_KEY, country);
  }

  public get addressLine1(): string {
    return this.get(SFLLocation.ADDRESS_LINE_1_KEY);
  }

  public set addressLine1(addressLine1: string) {
    this.set(SFLLocation.ADDRESS_LINE_1_KEY, addressLine1);
  }

  public get geoPoint(): Parse.GeoPoint {
    return this.get(SFLLocation.GEO_POINT_KEY);
  }

  public set geoPoint(geoPoint: Parse.GeoPoint) {
    this.set(SFLLocation.GEO_POINT_KEY, geoPoint);
  }
}

Parse.Object.registerSubclass(SFLLocation.CLASS_NAME, SFLLocation);



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/data/sfl-location.ts